import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../helpers';
import { TREATMENT_PLANS_V2_API_BASE } from '../../constants';

import type {
  ITreatmentPlanV3InformationPage,
  GetTreatmentPlanV3InformationPagePayload,
} from './types';

export function createTreatmentPlanV3InformationThunks() {
  return {
    getTreatmentPlanV3InformationPage: getTreatmentPlanV3InformationPage(),
  };
}

function getTreatmentPlanV3InformationPage() {
  return createAsyncThunk<
    ITreatmentPlanV3InformationPage,
    GetTreatmentPlanV3InformationPagePayload
  >(
    'treatmentPlanV3/getTreatmentPlanV3InformationPage',
    async ({ treatmentPlanId, getAccessTokenSilently }) =>
      fetchWrapper.get({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/information/`,
        getAccessTokenSilently,
      }),
  );
}
